module.exports = "<ul ng-show=\"$ctrl.filterOptions.hasValues()\" class=\"list-unstyled list-inline\">\n    <li ng-repeat=\"item in $ctrl.filterOptions.filterItems\" ng-if=\"item.value != ''\"><strong>{{item.label}}: </strong>{{item.value}}</li>\n    \n    <li><button class=\"btn btn-default clear-filter\" ng-click=\"$ctrl.clearFilter()\">Pulisci filtri <i class=\"fa fa-times\"></i></button></li>\n</ul>";


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/components/filter-selection/filter-selection.html
// module id = 1357
// module chunks = 0